// BASE
export const base = {
  REQUEST: 'REQUEST',
  SUCCESS: 'SUCCESS',
  FINALLY: 'FINALLY',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  ERROR: 'ERROR',
  PUSH_ITEM: 'PUSH_ITEM',
  PAGINATION: 'PAGINATION',
  RESET: 'RESET'
}
// TOOLBAR
export const toolbar = {
  SET_DRAWER: 'SET_DRAWER',
  SET_MIN_TOOLBAR: 'SET_MIN_TOOLBAR',
  EXTENSION: 'EXTENSION',
  STICKY_SEARCH: 'STICKY_SEARCH'
}
// SNACKBAR
export const snackbar = {
  SET_SNACKBAR_SHOW: 'SET_SNACKBAR_SHOW',
  SET_SNACKBAR_COLOR: 'SET_SNACKBAR_COLOR',
  SET_SNACKBAR_TEXT: 'SET_SNACKBAR_TEXT',
  SET_SNACKBAR_SUBTEXT: 'SET_SNACKBAR_SUBTEXT',
  SET_SNACKBAR_TIMEOUT: 'SET_SNACKBAR_TIMEOUT'
}
// DIALOG
export const dialog = {
  DIALOG_SHOW: 'DIALOG_SHOW'
}
// PAYMENTS
export const payments = {
  SET_PLAN: 'SET_PLAN',
  FETCHING_PLANS: 'FETCHING_PLANS',
  FETCHING_PLANS_SUCCESS: 'FETCHING_PLANS_SUCCESS',
  FETCHING_PLANS_ERROR: 'FETCHING_PLANS_ERROR'
}
// AUTH
export const register = {
  REGISTER_REQUEST: 'REGISTER_REQUEST',
  REGISTER_SUCCESS: 'REGISTER_SUCCESS',
  REGISTER_ERROR: 'REGISTER_ERROR',
  REGISTER_RESET: 'REGISTER_RESET',
  REGISTER_STEPPER_TYPE: 'REGISTER_STEPPER_TYPE'
}
// USERS
export const users = {
  USERS_REQUEST: 'USERS_REQUEST',
  USERS_SUCCESS: 'USERS_SUCCESS',
  USERS_ERROR: 'USERS_ERROR',
  USERS_SET_USERS: 'USERS_SET_USERS'
}
// CATALOGS
export const catalogs = {
  CATALOGS_REQUEST: 'CATALOGS_REQUEST',
  CATALOGS_SUCCESS: 'CATALOGS_SUCCESS',
  CATALOGS_ERROR: 'CATALOGS_ERROR',
  CATALOGS_QUOTE: 'CATALOGS_QUOTE',
  CATALOGS_SUBCATEGORY: 'CATALOGS_SUBCATEGORY'
}

// Unsubscribe
export const unsubscribe = {
  UNSUBSCRIBE_REQUEST: 'UNSUBSCRIBE_REQUEST',
  UNSUBSCRIBE_SUCCESS: 'UNSUBSCRIBE_SUCCESS',
  ERROR: 'ERROR',
  JOBS_PAGINATION: 'JOBS_PAGINATION'
}

// JOBS
export const jobs = {
  JOBS_REQUEST: 'JOBS_REQUEST',
  JOBS_SUCCESS: 'JOBS_SUCCESS',
  POSTCODE: 'POSTCODE',
  ERROR: 'ERROR',
  JOBS_PAGINATION: 'JOBS_PAGINATION',
  JOBS_NEW_SUCCESS: 'JOBS_NEW_SUCCESS'
}
// NANNIES
export const nannies = {
  NANNIES_REQUEST: 'NANNIES_REQUEST',
  NANNIES_SUCCESS: 'NANNIES_SUCCESS',
  POSTCODE: 'POSTCODE',
  ERROR: 'ERROR',
  NANNIES_RESET: 'NANNIES_RESET',
  NANNIES_PAGINATION: 'NANNIES_PAGINATION'
}
// FAVOURITES
export const favourites = {
  FAVOURITES_REQUEST: 'FAVOURITES_REQUEST',
  FAVOURITES_SUCCESS: 'FAVOURITES_SUCCESS',
  FAVOURITES_ERROR: 'FAVOURITES_ERROR',
  FAVOURITES_UPDATE: 'FAVOURITES_UPDATE',
  FAVOURITES_PUSH_ITEM: 'FAVOURITES_PUSH_ITEM',
  FAVOURITES_DELETE: 'FAVOURITES_DELETE'
}
// ARTICLES
export const articles = {
  ARTICLES_REQUEST: 'ARTICLES_REQUEST',
  ARTICLES_SUCCESS: 'ARTICLES_SUCCESS',
  ARTICLES_CATEGORIES_SUCCESS: 'ARTICLES_CATEGORIES_SUCCESS',
  ARTICLES_PAGINATION: 'ARTICLES_PAGINATION',
  ARTICLES_RESET: 'ARTICLES_RESET',
  ARTICLES_ERROR: 'ARTICLES_ERROR'
}

export const heardFrom = {
  HEARDFROM_REQUEST: 'HEARDFROM_REQUEST',
  HEARDFROM_SUCCESS: 'HEARDFROM_SUCCESS',
  HEARDFROM_SELECTED: 'HEARDFROM_SELECTED',
  HEARDFROM_ERROR: 'HEARDFROM_ERROR'
}



// WEBPACK FOOTER //
// ./src/store/types/mutation-types.js